import {roles} from "@/Enums";

const readIssuersPolicy = [
  roles.Hauptbenutzer,
  roles.Benutzer,
  roles.BenutzerGeber,
  roles.BenutzerFinanz,
  roles.BenutzerAussen
];

const editIssuersPolicy = [
  roles.Hauptbenutzer,
  roles.Benutzer,
  roles.BenutzerGeber,
  roles.BenutzerAussen
];

const downloadIssuerReportsPolicy = [
  roles.Hauptbenutzer,
  roles.Benutzer,
  roles.BenutzerGeber,
  roles.BenutzerFinanz,
  roles.BenutzerAussen
];

export {
  readIssuersPolicy,
  editIssuersPolicy,
  downloadIssuerReportsPolicy
}
